// extracted by mini-css-extract-plugin
export default {"input":"styles_input__VmBSp","controls":"styles_controls__bTtPq","info":"styles_info__3IoEF"};